import { RichEditor } from '@lmc/ui-kit'
import { prepareRichEditorContent } from '@lmc/ui-kit/src/dataEntry/RichEditor/normalizeRichEditorHtmlForStorage'
import { hasMeaningfulStoredHtml } from 'common/utils/html'
import { ViewStoredHtml } from 'components/generic/ViewStoredHtml'
import { Suspense } from 'react'

interface RichTextFormFieldProps {
  disabled?: boolean
  testId?: string
  // value/onChange are injected by the parent antd FormItem.
  value?: string
  onChange?: (value: string) => void
}

/**
 * RichEditor wired as a controlled antd FormItem child. In read mode (disabled)
 * it renders stored HTML via ViewStoredHtml, or nothing when there's no
 * meaningful content. Shared by goals (CM-2134) and resident profile (CM-3081).
 */
export const RichTextFormField = ({
  disabled = false,
  onChange,
  testId,
  value
}: RichTextFormFieldProps) => {
  if (disabled) {
    return hasMeaningfulStoredHtml(value) ? (
      <ViewStoredHtml html={prepareRichEditorContent(value)} />
    ) : null
  }

  return (
    <div data-testid={testId}>
      <Suspense fallback={null}>
        <RichEditor
          html={value ?? ''}
          onChangeHtml={(html) => onChange?.(html ?? '')}
        />
      </Suspense>
    </div>
  )
}
